function showCFPT_old()
      {    
        var cfptBuild = '';

        for (i = 0; i < listNoStim[trialRow]; i++) {
            cfptBuild += '<li class="ui-state-default" id="item_' + (i+1) + '"><img id="CFPT_' + (i+1) + '" /></li>';
        }
        $('#sortImg').append(cfptBuild);

        document.getElementById("topRight").style.color = "black";
        document.getElementById("CFPT").style.opacity = "1";

        for (i = 0; i < listNoStim[trialRow]; i++) {
            document.getElementById('CFPT_'+(i+1)).src = images[i+1][trialRow].src;
            document.getElementById('CFPT_'+(i+1)).width = adjuster * images[i+1][trialRow].width;
            document.getElementById('CFPT_'+(i+1)).height = adjuster * images[i+1][trialRow].height;
        }

        CFPTcorrectOrder = [listArrays[allColumns.indexOf('sort1')][trialRow], listArrays[allColumns.indexOf('sort2')][trialRow], listArrays[allColumns.indexOf('sort3')][trialRow], listArrays[allColumns.indexOf('sort4')][trialRow], listArrays[allColumns.indexOf('sort5')][trialRow], listArrays[allColumns.indexOf('sort6')][trialRow]];
        CFPTdisplayOrder = [listArrays[allColumns.indexOf('stim1')][trialRow], listArrays[allColumns.indexOf('stim2')][trialRow], listArrays[allColumns.indexOf('stim3')][trialRow], listArrays[allColumns.indexOf('stim4')][trialRow], listArrays[allColumns.indexOf('stim5')][trialRow], listArrays[allColumns.indexOf('stim6')][trialRow]];

        CFPTstartOrderItems = [$("#item_1").index(),$("#item_2").index(),$("#item_3").index(),$("#item_4").index(),$("#item_5").index(),$("#item_6").index()];
        CFPTstartOrderStim = [CFPTcorrectOrder.indexOf(listArrays[allColumns.indexOf('stim1')][trialRow]),CFPTcorrectOrder.indexOf(listArrays[allColumns.indexOf('stim2')][trialRow]),CFPTcorrectOrder.indexOf(listArrays[allColumns.indexOf('stim3')][trialRow]),CFPTcorrectOrder.indexOf(listArrays[allColumns.indexOf('stim4')][trialRow]),CFPTcorrectOrder.indexOf(listArrays[allColumns.indexOf('stim5')][trialRow]),CFPTcorrectOrder.indexOf(listArrays[allColumns.indexOf('stim6')][trialRow])];

        document.getElementById("CFPT").style.top = (canvasHeight/2 - $('#image1').height()/2 - borderImage + verticalShift) + "px";//don't know where 15 is coming from
        document.getElementById("CFPT").style.display = "block";

        $('#sortImg').sortable({ disabled: false });//old sortable

        startTimerCFPT(listArrays[allColumns.indexOf('presTime')][trialRow]/1000);
        show("topRight");
        //following line is kept only for back compatibility

        displayText("topLeft",iBlock+"/"+nTrialsBlock[listBlockNo[trialRow]]);//display "trial i of n"

        displayText("leftArrowText",listArrays[allColumns.indexOf('leftArrow')][trialRow]);
        displayText("rightArrowText",listArrays[allColumns.indexOf('rightArrow')][trialRow]);
        document.getElementById("leftArrow").src = "http://www.ucl.ac.uk/lagnado-lab/experiments/costi/platform/test/images/misc/arrowLeft.png"; //not preloaded
        document.getElementById("rightArrow").src = "http://www.ucl.ac.uk/lagnado-lab/experiments/costi/platform/test/images/misc/arrowRight.png"; //not preloaded
        document.getElementById("leftArrow").style.width = (80*adjuster)+"px";
        document.getElementById("rightArrow").style.width = (80*adjuster)+"px";
        document.getElementById("arrows").style.display="block";
        document.getElementById("arrowsText").style.display="block";
      }